import { getFAQ } from 'app/shared/components/MarketFAQ';
import type MarketTrends from 'app/shared/models/MarketTrends';

export function getStructuredData(marketTrends: MarketTrends) {
  return [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        mainEntity: getFAQ(marketTrends).map((qAndA: { question: string; answer: string }, i) => {
          const { question, answer } = qAndA;
          return {
            '@type': 'Question',
            name: `${i + 1}. ${question}`,
            acceptedAnswer: {
              '@type': 'Answer',
              text: `<p>${answer}</p>`,
            },
          };
        }),
      }),
    },
  ];
}
